import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

/**
 * Publish a draft promotion (`POST offers/:id/promote-draft`) so a launch it
 * blocked can be retried. For launch paths without `publishDraftPromotion`.
 */
export const usePublishDraftPromotion = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (offerId: string) =>
      apiClient.post(`offers/${offerId}/promote-draft`),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.offers.all() });
      void queryClient.invalidateQueries({ queryKey: queryKeys.metaAds.all() });
    },
  });
  return {
    publishAsync: mutation.mutateAsync,
    isPublishing: mutation.isPending,
  };
};
